export default {"src":"/_next/static/media/pets-some-focus.c282c530.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};